module.exports = {"A__FF3A3A3A":"#ff3a3a3a","A__FFFFFFFF":"#ffffffff","A__FFFF0000":"#ffff0000","A__FF4A494A":"#ff4a494a","A__FF000000":"#ff000000","A__FFEE0000":"#ffee0000","A__FFED0000":"#ffed0000","A__FFCCCCCC":"#ffcccccc"}


//////////////////
// WEBPACK FOOTER
// ./res/fontColor.json
// module id = 7
// module chunks = 0